module.exports = __webpack_public_path__ + "FixelDisplay-MediumItalic-cdbd8b39846c459e96c57f574696e227.woff2";